import axios from "axios";
import authHeader from "./auth-header";
import { API_URL_COMMON } from "./http.common";

const API_URL =
  API_URL_COMMON || `https://magicstamp-portal-sa.parktechnology.com`;

class StampcardService {
  getCardDeletions(params) {
    return axios({
      method: "get",
      url: `${API_URL}/stamp-card-deletions`,
      headers: authHeader(),
      params: params,
    });
  }

  acceptCardDeletions(id) {
    return axios({
      method: "put",
      url: `${API_URL}/stamp-card-deletions/${id}/accept`,
      headers: authHeader(),
    });
  }

  rejectCardDeletions(id) {
    return axios({
      method: "put",
      url: `${API_URL}/stamp-card-deletions/${id}/reject`,
      headers: authHeader(),
    });
  }

  deleteCardDeletions(id) {
    return axios({
      method: "delete",
      url: `${API_URL}/stamp-card-deletions/${id}`,
      headers: authHeader(),
    });
  }

  getIcons({ account_urn, type, theme }) {
    return axios({
      method: "get",
      url: `${API_URL}/stamp-cards/icons/${type}/${theme}`,
      headers: authHeader(null, {
        account_urn,
      }),
    });
  }

  deleteStampcard(data) {
    return axios({
      method: "post",
      url: `${API_URL}/stamp-card-deletions`,
      headers: authHeader(),
      data,
    });
  }

  uploadIcon({ data, accUrn, businessSlug }) {
    return axios({
      method: "post",
      url: `${API_URL}/icon-manager/${businessSlug}/card-assets`,
      headers: authHeader("multipart/form-data", { account_urn: accUrn }),
      data: data,
    });
  }

  uploadLogo({ data, accUrn, businessSlug }) {
    return axios({
      method: "post",
      url: `${API_URL}/icon-manager/${businessSlug}/logos`,
      headers: authHeader("multipart/form-data", { account_urn: accUrn }),
      data: data,
    });
  }

  uploadBackground({ data, accUrn, businessSlug }) {
    return axios({
      method: "post",
      url: `${API_URL}/icon-manager/${businessSlug}/backgrounds`,
      headers: authHeader("multipart/form-data", { account_urn: accUrn }),
      data: data,
    });
  }
}

export default new StampcardService();
